import request from '../utils/request'

export function userGet () {
  return request.get('/da/user', {}, { login: true })
}

export function patientGet (patientId) {
  return request.get(`/da/patient/${patientId}`)
}

export function patientList () {
  return request.get('/da/patientList')
}

export function patientCreate (data) {
  return request.post('/da/patientCreate', data)
}
export function patientUpdate (data) {
  return request.post('/da/patientUpdate', data)
}
export function patientDelete (patientId) {
  return request.post('/da/patientDelete', { id: patientId })
}
